module.exports = __webpack_public_path__ + "static/img/contract-name.79429d8d.png";